<template>
	<div class="edit-list">
		<div>
			<div v-for="(item, i) in dataList" :key="i" class="item">
				<unit-edit-form v-model="dataList[i]" ref="form" :config="config.content"></unit-edit-form>
				
				<div class="item-index">{{i + 1}}</div>
				<div class="item-handle flex-center">
					<a class="sort-up" @click="sortHandle(i, 0)"><i class="tf tf-sort-top"></i></a>
					<a class="sort-up" @click="sortHandle(i, i - 1)"><i class="tf tf-sort-up"></i></a>
					<a class="sort-down" @click="sortHandle(i, i + 1)"><i class="tf tf-sort-down"></i></a>
					<a class="sort-down" @click="sortHandle(i, dataList.length - 1)"><i class="tf tf-sort-bottom"></i></a>
					<a v-if="!config.length" @click="removeHandle(i)"><i class="tf tf-cross"></i></a>
				</div>
			</div>
		</div>
		<div v-if="!config.length" class="flex-center">
			<c-button size="m" icon="add" @click="addHandle">添加一项</c-button>
		</div>
	</div>
</template>

<script>
	export default {
		components: {
			unitEditForm: () => import('./unit_edit_form.vue')
		},
		
		props: {
			config: Object
		},
		
		data() {
			return {
				dataList: this.config.length ? Array.from(new Array(this.config.length), item => {
					return {};
				}) : []
			}
		},
		
		methods: {
			addHandle() {
				this.dataList.push({});
			},
			
			removeHandle(index) {
				this.dataList.splice(index, 1);
			},
			
			sortHandle(index, target) {
				if (target < 0 || target >= this.dataList.length) return;
				let item = this.dataList.splice(index, 1)[0];
				this.dataList.splice(target, 0, item);
			},
			
			set(data) {
				if (this.config.length) {
					this.dataList = Array.from(this.dataList, (item, index) => {
						return data[this.config.code] && data[this.config.code][index] ? data[this.config.code][index] : {};
					});
				} else {
					this.dataList = data[this.config.code] || [];
				}
			},
			
			submit: async function() {
				let data = []
				if (this.$refs.form) {
					for (let i = 0; i < this.$refs.form.length; i++) {
						let temp = await this.$refs.form[i].submit();
						data.push(temp);
					};
				}
				
				return {
					[this.config.code]: data
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import '~@/assets/style/theme';
	
	.edit-list {
		.item {
			position: relative;
			padding: 30px 20px 0;
			border: 1px solid #ddd;
			margin-bottom: 10px;
			background: #F8F8F8;
			
			&:nth-child(1) .sort-up,
			&:nth-last-child(1) .sort-down {
				display: none;
			}
			
			&-index {
				position: absolute;
				left: 0;
				top: 0;
				box-sizing: border-box;
				min-width: 20px;
				padding: 0 5px;
				line-height: 20px;
				font-size: 12px;
				text-align: center;
				color: #fff;
				theme-background(lesser);
			}
			
			&-handle {
				position: absolute;
				right: 2px;
				top: 2px;
				
				a {
					width: 20px;
					height: 20px;
					margin-left: 2px;
					line-height: 20px;
					text-align: center;
					font-size: 13px;
					theme-color(lesser);
					
					&:hover {
						theme-color(main);
					}
				}
			}
		}
	}
</style>
